"use strict";

var _classCallCheck = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/render/project/src/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vector3d = void 0;

var Vector_1 = require("./Vector");

var Vector3d = /*#__PURE__*/function (_Vector_1$Vector) {
  _inherits(Vector3d, _Vector_1$Vector);

  var _super = _createSuper(Vector3d);

  function Vector3d(x, y, z) {
    var _this;

    _classCallCheck(this, Vector3d);

    _this = _super.call(this, x, y);
    _this.z = z === undefined ? x.z : z;
    return _this;
  }

  _createClass(Vector3d, [{
    key: "add",
    value: function add(v) {
      return v instanceof Vector3d ? Vector3d.create(this.x + v.x, this.y + v.y, this.z + v.z) : _get(_getPrototypeOf(Vector3d.prototype), "add", this).call(this, v);
    }
  }, {
    key: "addTo",
    value: function addTo(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "addTo", this).call(this, v);

      if (v instanceof Vector3d) {
        this.z += v.z;
      }
    }
  }, {
    key: "sub",
    value: function sub(v) {
      return v instanceof Vector3d ? Vector3d.create(this.x - v.x, this.y - v.y, this.z - v.z) : _get(_getPrototypeOf(Vector3d.prototype), "sub", this).call(this, v);
    }
  }, {
    key: "subFrom",
    value: function subFrom(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "subFrom", this).call(this, v);

      if (v instanceof Vector3d) {
        this.z -= v.z;
      }
    }
  }, {
    key: "mult",
    value: function mult(n) {
      return Vector3d.create(this.x * n, this.y * n, this.z * n);
    }
  }, {
    key: "multTo",
    value: function multTo(n) {
      _get(_getPrototypeOf(Vector3d.prototype), "multTo", this).call(this, n);

      this.z *= n;
    }
  }, {
    key: "div",
    value: function div(n) {
      return Vector3d.create(this.x / n, this.y / n, this.z / n);
    }
  }, {
    key: "divTo",
    value: function divTo(n) {
      _get(_getPrototypeOf(Vector3d.prototype), "divTo", this).call(this, n);

      this.z /= n;
    }
  }, {
    key: "copy",
    value: function copy() {
      return Vector3d.clone(this);
    }
  }, {
    key: "setTo",
    value: function setTo(v) {
      _get(_getPrototypeOf(Vector3d.prototype), "setTo", this).call(this, v);

      if (v instanceof Vector3d) {
        this.z = v.z;
      }
    }
  }], [{
    key: "clone",
    value: function clone(source) {
      return Vector3d.create(source.x, source.y, source.z);
    }
  }, {
    key: "create",
    value: function create(x, y, z) {
      return new Vector3d(x, y, z);
    }
  }]);

  return Vector3d;
}(Vector_1.Vector);

exports.Vector3d = Vector3d;